import React, { useState, useEffect } from 'react'
import "./viewAllProjects.css"
import Nav from '../../globalComponents/nav/Nav';
import Footer from '../../globalComponents/footer/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { MDBAccordion, MDBAccordionItem, MDBBtn, MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem } from 'mdb-react-ui-kit';
import Url from '../url'

function ViewAllProjects() {
    const navigate = useNavigate()
    const [token, setToken] = useState(null)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [admin, setAdmin] = useState(null)
    const [tokenLoaded, setTokenLoaded] = useState(false)
    const [allProjectsLoaded, setAllProjectsLoaded] = useState(false)
    const [allProjects, setAllProjects] = useState([])


    useEffect(() => {
        if (localStorage.getItem("user")) {

            setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ? setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0, 3) + localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
        
    },[])

    useEffect(() => {
        if (token && !allProjectsLoaded) {
            console.log(`fetching with token ` + token)

            fetch(Url+`project/getAllProjects`, {
                method: "GET",
                body: null,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })

            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        alert(`${data.error}`)
                    }
                    else {
                        console.log(data)
                        setAllProjects(data.projects)
                        setAllProjectsLoaded(true)
                    }
                })
                .catch(err => { console.log(err) })
        }

    }, [token])

    const claimAction = (status, targetId) => {
        console.log(status)
        console.log("targetid here" + targetId)
        if (tokenLoaded) {
            console.log("hit past token loaded")
            
            fetch(Url+'project/updateProjectStatus', {
                method: "POST",
                body:
                    JSON.stringify({ status: status, projectId: targetId })
                ,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log("Data here", data)
                })
                
                .catch(err => console.log(err))
        }
    }
    
    return (
        <div>
            <Nav></Nav>
            {allProjectsLoaded &&
                <div className='container-sm' style={{ marginTop: "120px" }}>
                    <h3>All projects</h3>
                    <MDBAccordion initialActive={0} alwaysOpen>
                        {
                            allProjects ? allProjects.map((project, key) => {
                                return (

                                    <MDBAccordionItem collapseId={key + 1}
                                        headerTitle={

                                            <div className='container'>
                                                <div className='col-md-3'>
                                                    <strong>{project.projectInfo.projectName}</strong>
                                                </div>
                                                <div className='col-md-3'>
                                                    <small><i>Posted on</i> {project.projectInfo.createdAt.split('T')[0]}</small>
                                                    <small><i> by </i> {project.projectOwnerInfo.fName + " " + project.projectOwnerInfo.lName}</small>
                                                </div>



                                                <div className='col'>
                                                    {/* <span className="text-light bg-dark">{project.projectInfo.status}</span> */}
                                                    <p className='col-md-1 status' style={{marginLeft: "0.25rem", marginRight: "0.25rem", paddingLeft: "0.25rem", paddingRight: "0.25rem"}}>
                                                        <strong>{project.projectInfo.status.toUpperCase()}</strong></p>
                                                </div>

                                                    {
                                                    project.projectInfo.status =="claimed" 
                                                        ? <div className='col-md-5'>
                                                            <small><i>Claimed on</i> {project.projectInfo.updatedAt.split('T')[0]}
                                                            <i> by </i> {project.finisherInfo.fName + " " + project.finisherInfo.lName}
                                                        
                                                            </small>
                                                        </div>
                                                        : null
                                                    }
                                                

                                            </div>
                                        }


                                        key={project.projectInfo._id}
                                    >

                                        <div className='row'>
                                            <div className='col'>
                                                <p><strong> {project.projectInfo.projectName ? project.projectInfo.projectName : null}</strong></p>
                                                <p>Project Owner: {project.projectOwnerInfo.fName + " " + project.projectOwnerInfo.lName}</p>
                                                <p>Description: {project.projectInfo.projectDescription ? project.projectInfo.projectDescription : null}</p>
                                                
                                            </div>
                                        </div>

                                        <MDBDropdown>
                                        <MDBDropdownToggle className='hidden-arrow'>Project Options</MDBDropdownToggle>
                                            <MDBDropdownMenu>
                                                
                                                <MDBDropdownItem onClick={e => {
                                                    
                                                    navigate(`/updateProject/${project.projectInfo._id}`)
                                                }} link>Edit Project</MDBDropdownItem>

                                                <MDBDropdownItem onClick={e => {
                                                    claimAction( "available", project.projectInfo._id)
                                                    navigate("/")
                                                }} link>Reset Project To Available</MDBDropdownItem>
                                            </MDBDropdownMenu>
                                        </MDBDropdown>

                                    </MDBAccordionItem>
                                )

                            })
                                : <h1>Loading Projects</h1>


                        }


                    </MDBAccordion>
                </div>

            }

            <div style={{ marginTop: "100px" }}>

            </div>

            <Footer></Footer>
        </div>
    )
}

export default ViewAllProjects